import { render, staticRenderFns } from "./MAN906M01.vue?vue&type=template&id=c647bd34&"
import script from "./MAN906M01.vue?vue&type=script&lang=js&"
export * from "./MAN906M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports